export const DISPLAY_EVENTS_IN_DDL = 'DISPLAY_EVENTS_IN_DDL';
export const HIDE_SQUAD_DIALOG = 'HIDE_SQUAD_DIALOG';
export const HIDE_SQUAD_DELETE_DIALOG = 'HIDE_SQUAD_DELETE_DIALOG';
export const DISPLAY_SQUAD_DIALOG = 'DISPLAY_SQUAD_DIALOG';
export const DISPLAY_NEXT_MONTH = 'DISPLAY_NEXT_MONTH';
export const DISPLAY_PREVIOUS_MONTH = 'DISPLAY_PREVIOUS_MONTH';
export const DISPLAY_TOURNAMENT_SQUADS = 'DISPLAY_TOURNAMENT_SQUADS';
export const DISPLAY_SPECIFIC_MONTH = 'DISPLAY_SPECIFIC_MONTH';
export const DISPLAY_SQUAD_DELETE_MODAL = 'DISPLAY_SQUAD_DELETE_MODAL';
export const DISPLAY_SQUAD_DELETE_CONFIRM_MODAL = 'DISPLAY_SQUAD_DELETE_CONFIRM_MODAL';
export const ERROR_UNTIL_REQUIRED = 'Please enter a valid date to repeat until.';
export const ERROR_UNTIL_BEFORE_START_DATE = 'Repeat until date must be after squad date.';
export const ERROR_UNTIL_AFTER_END_DATE = `Can't repeat past tournament end date.`;



// WEBPACK FOOTER //
// ./src/features/tournament/squads/constants.js